// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../demo/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ProseMirror .trailing-paragraph {\n  position: relative;\n}\n.ProseMirror .trailing-paragraph::before {\n  content: 'Enter text here...';\n  position: absolute;\n  top: 0;\n  color: #cccccc;\n  pointer-events: none;\n  left: 4px;\n}\n", ""]);
// Exports
module.exports = exports;
